// jQuery bxSlider configuration
define('app/slider',['jquery-private'], function($) {
	
	var Slideshow = function(opts) {

		this.el = (opts.el) ? opts.el : null;
		this.images = (opts.images) ? opts.images : [];
		this.duration = (opts.duration) ? opts.duration : 3500;
		this.interval = (opts.interval) ? opts.interval : 0;
		this.curr_slide = 0;
		
		var holder = '<div class="slideshow-holder" />',
			slide_a,
			slide_b,
			slideshow,
			that = this;

		this.init = function() {
			// Setup HTML
			this.el.append(holder);
			holder = $('.slideshow-holder', this.el);

			holder.append('<div class="slide slide-a" style="background-image: url('+ this.images[0] +'); z-index: 2;" />');
			slide_a = $('.slide-a', holder);

			holder.append('<div class="slide slide-b" style="background-image: url('+ this.images[1] +'); z-index: 1;" />');
			slide_b = $('.slide-b', holder);

			// Start slideshow
			this.transition(1);
		};

		this.transition = function(slide) {
			slide_a.fadeOut(that.duration, function() {
				next_slide = (slide+1 < that.images.length) ? slide+1 : 0;

				slide_a.css('background-image', 'url('+ that.images[slide] +')').show();
				slide_b.css('background-image', 'url('+ that.images[next_slide] +')');

				that.transition(next_slide);
			});
		};

		this.destroy = function() {
			holder.remove();
			this.el.removeAttr('style');
		};
	};

	return Slideshow;

});
